import { render, staticRenderFns } from "./CalendarDetailDialog.vue?vue&type=template&id=203b9fe2&"
import script from "./CalendarDetailDialog.vue?vue&type=script&lang=js&"
export * from "./CalendarDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDetailDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDialog,VIcon,VRow})
